/*=========================================================================================
  File Name: moduleDocumentUploadActions.js
  Description: DocumentUpload Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from '@/plugins/axios';
//import { DocumentTypeEntityModel } from "../../../models/EntityModels/DocumentTypeEntityModel";
//import { DocumentUploadEntityModel } from "../../../models/EntityModels/DocumentUploadEntityModel";

export default {
  async CreateDocumentUpload({}, Credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post('document-uploads', Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  async GetDocumentUpload({}, Id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`document-uploads/${Id}`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  async GetDocumentUploadById({}, credential) {
    return new Promise((resolve, reject) => {
      axios
        .get(`document-uploads/${credential.id}`)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  async EditDocumentUpload({}, credentials) {
    let newId = credentials.id;
    delete credentials.Id;
    delete credentials.id;
    delete credentials.created_at;
    delete credentials.Document_path;
    delete credentials.updated_at;
    delete credentials.deleted_at;
    delete credentials.is_active;
    return new Promise((resolve, reject) => {
      axios
        .patch(`document-uploads/${newId}`, credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  async GetDocumentUploads({}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`document-uploads`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  ArchiveOrActiceDocumentUpload({}, Id) {
    return new Promise((resolve, reject) => {
      axios

        .get(`document-uploads/${Id}/soft-delete`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetDocumentUploadTypes({}) {
    return new Promise((resolve, reject) => {
      axios
        .get('document-types')
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  GetDocumentTypeSearch({}, payload) {
    let url = 'document-types/search?';
    if (payload != null && payload != undefined) {
      if (payload.query != '' && payload.query != null) {
        url += `query=${payload.query}&`;
      }
      if (payload.status != '' && payload.status != null) {
        url += `status=${payload.status}`;
      }
      if (
        payload.except != undefined &&
        payload.except != null &&
        payload.except.length > 0
      ) {
        url += `except=[${payload.except}]`;
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
};
